import { useMemo } from "react"
import { useLocalization } from "@fluent/react"
import { ModalTitlePlacement, type ModalUserPrompt, PermissionType, TransitionType, UserPromptActionType, UserPromptType } from "./userTypes"
// Bundled locally: the app CSP (connect-src) and the LottieFiles CDN (no CORS headers) both block loading it by URL
import NotificationBellAnim from "./Assets/notification-bell-lottie-anim.json?url"

// TEMPORARY (task 328): hardcoded copy of the expected `GET /me/prompts` response for the notification
// permission prompt (see PUSH_NOTIFICATIONS.md, section 2). Used to trigger the permission prompt at
// startup until the backend delivers it / the prompting flow is redesigned.
export const PUSH_PERMISSION_PROMPT_ID = "push-notifications-consent"

export function usePushPermissionPrompt(): ModalUserPrompt {
    const { l10n } = useLocalization()

    const title = l10n.getString("push-permission-prompt-title")
    const intro = l10n.getString("push-permission-prompt-intro")
    const benefitOffers = l10n.getString("push-permission-prompt-benefit-offers")
    const benefitOrderChanges = l10n.getString("push-permission-prompt-benefit-order-changes")
    const buttonAllow = l10n.getString("push-permission-prompt-button-allow")

    return useMemo(() => ({
        id: PUSH_PERMISSION_PROMPT_ID,
        type: UserPromptType.MODAL,
        modalDetails: {
            content: {
                title,
                // Rendered as Markdown by ModalUserPrompt
                text: `${intro}\n\n* ${benefitOffers}\n* ${benefitOrderChanges}`,
                animationUrl: NotificationBellAnim,
                dismissable: true,
            },
            actions: [
                {
                    type: UserPromptActionType.REQUEST_PERMISSION,
                    label: buttonAllow,
                    permissionRequestDetails: {
                        permission: PermissionType.NOTIFICATIONS,
                    },
                    layout: {
                        variant: "contained",
                        color: "black",
                    },
                },
            ],
            layout: {
                title: { placement: ModalTitlePlacement.BELOW_MEDIA, align: "center" },
                text: { variant: "body2" },
            },
            transitionType: TransitionType.ZOOM,
        },
    }), [title, intro, benefitOffers, benefitOrderChanges, buttonAllow])
}
